"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _PageLoadingSpinner = _interopRequireDefault(require("@jobmatchme/ui/es/components/PageLoadingSpinner"));

var _DescriptionLine = _interopRequireDefault(require("../DescriptionLine"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _StaticMap = _interopRequireDefault(require("../../StaticMap"));

var _Diagnostic = _interopRequireDefault(require("../Diagnostic"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var KununuIFrame = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* app: 'webpackKununuIFrame' */
  '@jobmatchme/ui/es/components/KununuIFrame');
}); // ABTest
// Variant B Offer Description Data

var OfferData = function OfferData(_ref) {
  var t = _ref.t,
      diagnosticFit = _ref.diagnosticFit,
      descriptionLines = _ref.descriptionLines,
      _ref$preview = _ref.preview,
      preview = _ref$preview === void 0 ? false : _ref$preview,
      index = _ref.index,
      animation = _ref.animation,
      jobId = _ref.jobId,
      bcId = _ref.bcId,
      scrollerPath = _ref.scrollerPath,
      discriminator = _ref.discriminator,
      searchLocation = _ref.searchLocation,
      jobLocation = _ref.jobLocation;

  switch (animation) {
    case 'loading':
      return null;

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        direction: "row",
        id: scrollerPath,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          item: true,
          xs: 10,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            container: true,
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            children: descriptionLines.map(function (descriptionLine) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DescriptionLine.default, (0, _extends2.default)({
                index: index,
                discriminator: discriminator
              }, descriptionLine), 'dl' + index + '_' + descriptionLine.header.tKey);
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
            variant: "middle",
            className: _styleModule.default.divider
          }, 'd2d' + index), preview && discriminator !== 'service-gastro' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 10,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
              container: true,
              direction: "row",
              alignItems: "center",
              justifyContent: "center",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: t('pc-matching:JobOffer.preview')
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), discriminator !== 'service-gastro' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Diagnostic.default, {
              diagnostic: diagnosticFit || {},
              t: t
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
              variant: "middle",
              className: _styleModule.default.divider
            }, 'd2dd' + index)]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.iFrame,
            children: !preview && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
              fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PageLoadingSpinner.default, {}),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(KununuIFrame, {
                job: {
                  uuid: jobId,
                  bcUuid: bcId
                }
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.staticMap,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StaticMap.default, {
              id: 'bigmap' + index,
              jobLocation: jobLocation,
              discriminator: discriminator,
              searchLocation: searchLocation
            }, 'map' + index)
          })]
        })
      }, 'gr0' + index);
  }
};

var _default = /*#__PURE__*/(0, _react.memo)(OfferData);

exports.default = _default;